import React, { useEffect, useState, useMemo, useContext } from 'react';
import { useLocation, useParams } from 'react-router-dom';
import BackBtn from '../components/UI/BackBtn';

import './ProjectCreate.less';
import './Page.less';
import '../components/Form.less';
import { Tab, Tabs } from '../components/Tabs';
import ReportYear from '../components/ProjectReportTabs/ReportYear';
import TabIndexes from '../components/ProjectReportTabs/TabIndexes';
import api from '../api';
import { getProjectPerms, hasPermsOnIndexesOrReceipts, isCommandManagmentOrProjOffice, isProjectTeam } from '../services/rolesSvc';
import useUserContext from '../hooks/useUserContext';

import useNavProject from '../hooks/useNavProject';
import WidgetsGrid from '../components/_layout/WidgetsGrid';
import {BaseRequests} from "../requests/BaseRequests";
import { getPathType } from '../helpers/typeProject';


const defaultYear = Number(DEFAULT_YEAR_WEBPACK_REPORT);

export default function StratProjReport() {
  const { stratId, projId, reportYear,portfolioId } = useParams();
  const [project, setProject] = useState(null);
  const [permissions, setPermissions] = useState(null);

  useEffect(async () => {
    const respProject = await api.get(`/structure/projs/${projId}`);
    if (!respProject || respProject.error) return;
    setPermissions(getProjectPerms(userCtx, respProject.id, respProject.strategy?.id, respProject.portfolio?.id, respProject.policy?.id));
    setProject(respProject);
  }, []);

  const userCtx = useUserContext();
  const navProject = useNavProject();

  const routes = useMemo(() => [
        {name: 'Ежегодный отчёт', url: `/${getPathType(project?.strategy?.type)}/${stratId}${portfolioId ? `/portfolios/${portfolioId}/projs/${projId}/yearReport` : `/projs/${projId}/report`}/year/${reportYear ?? defaultYear}`, show: () => permissions?.canRead || permissions?.canWrite},
        {name: 'Унифицированные показатели проекта', url: `/${getPathType(project?.strategy?.type)}/${stratId}${portfolioId ? `/portfolios/${portfolioId}/projs/${projId}` : `/projs/${projId}`}/report/unified` , show: () => hasPermsOnIndexesOrReceipts(userCtx, {stratId, projId})},
        {name: 'Вехи проекта', url: `/${getPathType(project?.strategy?.type)}/${stratId}${portfolioId ? `/portfolios/${portfolioId}/projs/${projId}` : `/projs/${projId}`}/report/milestones` },
        {name: 'Поступления от научной и иновационной деятельности', url: `/${getPathType(project?.strategy?.type)}/${stratId}${portfolioId ? `/portfolios/${portfolioId}/projs/${projId}` : `/projs/${projId}`}/report/receipts`},
    ], [userCtx, stratId, projId, permissions, project])

  useEffect(async () => {
    const respProject = await api.get(`/structure/projs/${projId}`);
    if (!respProject || respProject.error) return;
    setPermissions(getProjectPerms(userCtx, respProject.id, respProject.strategy?.id, respProject.portfolio?.id));
    setProject(respProject);
    // СП или политика
    BaseRequests.getNavigationLinks(respProject,navProject)
  }, []);

  if (project && permissions) {
    return (
        <section className="page strat-proj-report-page" style={{ background: '#F5F5FF' }}>
          <div className="container">
            <div style={{ marginBottom: 16 }}>
              <BackBtn />
            </div>
            <WidgetsGrid items={routes}/>
          </div>
        </section>
    );
  }

  return <div style={{ color: 'red', background: 'white' }}>Загрузка...</div>;
}

const styledHeading = { marginBottom: 24, textAlign: 'left' };
const styledSubHeading = { marginBottom: 24, marginTop: 36, lineHeight: '23px' };
